import { useEffect, useRef } from 'react';
import TopPlayers from '../../assets/svg/leaderboard/top-players.svg';
import Energy from '../../assets/svg/utils/energy/energy-rtl.svg';
import { numberWithCommas } from '../../helpers';
import { useResizeObserver } from '../../hooks/useResizeObserver';
import { TopPlayerT } from '../../types';
import RocketIcon from '../../assets/svg/utils/rocket/rocket-highlighted.svg';
import LeagueIcon from '../LeagueIcon';
import ChestRewardIco from '../../assets/images/chests/chest-with-treasure.png';

type LeaderboardCurrentUserCardProps = Pick<TopPlayerT, 'username' | 'league'| 'rocket_coins' | 'next_league'> &{
    id?: string
    first_name?: string
    last_name?: string
}
function LeaderboardCurrentUserCard({
  username, first_name: firstName, last_name: lastName, league, rocket_coins: rocketCoins, id, next_league: nextLeague,
}: LeaderboardCurrentUserCardProps) {
  const leaderBoardCurrentUserContainerRef = useRef<HTMLDivElement>(null);

  const rect = useResizeObserver(leaderBoardCurrentUserContainerRef);

  useEffect(() => {
    if (!leaderBoardCurrentUserContainerRef.current || !rect) {
      return;
    }

    leaderBoardCurrentUserContainerRef.current.style.top = `${window.innerHeight - 155}px`;
  }, [rect]);
  const isUserPromotedToNextLeague = league.id < nextLeague.id;
  return (
    <div className="py-2 px-4 absolute z-[4] w-full" ref={leaderBoardCurrentUserContainerRef}>
      <div id={id} className="relative rounded-10 justify-between min-h-[77px] user-league-card">
        <div className={`user-league-card-bg ${isUserPromotedToNextLeague ? 'promoted' : ''} min-h-[77px] absolute h-full w-full`} />
        <div className={`top-line ${league?.name}`} />
        <div className={`bottom-line ${league?.name}`} />
        <div className="absolute h-full w-full flex justify-between items-center px-3 py-1 rounded-10 pt-[1.8rem] pl-[0.86rem] top-0">
          <div className="flex pl-[.225rem] pt-[0.1rem] translate-y-[-6px]">
            <div className="flex flex-col items-start">
              <div className="text-base font-bold font-Bangers tracking-[0.3px] flex gap-2">
                {username || (`${firstName} ${lastName}`)}
                {isUserPromotedToNextLeague
                    && (
                    <div className="main-gradient-border league-ready pl-2 font-Bangers text-[10px] rounded-10 flex items-center">
                      ready
                      <div className="h-[18px] translate-x-[0px] ml-1">
                        <LeagueIcon league={nextLeague.name} />
                      </div>
                    </div>
                    )}
              </div>
              <div className="flex items-center text-12 font-normal font-Inrias">
                {numberWithCommas(Number(rocketCoins.toFixed(0)))}
                <div className="ml-1">
                  <img src={RocketIcon} alt="rocket-icon" className="w-[16px]" />
                </div>
              </div>
            </div>
          </div>
          <div className={`text-26 my-auto mx-0 font-normal font-Bangers usercard-rank min-w-[44px] mr-[20px] pl-8 ${isUserPromotedToNextLeague ? '' : 'pr-8'} max-h-[40px] translate-y-[-7px] flex`}>
            #
            {numberWithCommas(league?.rank)}
            <div className="ml-2 translate-y-[-1px]">
              <div className="flex justify-start gap-1">
                {nextLeague?.rewards?.energy
                            && <EnergyReward value={(Number(nextLeague?.rewards?.energy || 0))} />}
                {nextLeague?.rewards?.rocket_coins_recovery_per_hour
                                          && <RocketCoinsReward value={Number(nextLeague?.rewards?.rocket_coins_recovery_per_hour || 0)} />}
                {nextLeague?.rewards?.launch_chest
                                          && <ChestReward value={nextLeague?.rewards?.launch_chest || 0} />}
                {nextLeague?.rewards?.orbit_chest
                && <ChestReward value={nextLeague?.rewards?.orbit_chest || 0} />}
              </div>
            </div>
            <span className="absolute h-[3.3rem] top-[-15px] right-[-15px]">
              <img src={TopPlayers} alt="top-players-icon" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeaderboardCurrentUserCard;

function EnergyReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img src={Energy} alt="energy-icon" className="w-[36px] translate-y-[4px]" />
      <div className={`absolute text-26 font-normal font-Bangers top-[10px] left-[-8px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF]
      `}
      >
        {value}
      </div>
    </div>
  );
}
function RocketCoinsReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img src={RocketIcon} alt="rocket-icon" className="w-[40px] translate-y-[2px]" />
      <div className={`absolute text-22 font-normal font-Bangers top-[14px] left-[-14px] px-2 
                     text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF] 
                     `}
      >
        {value}
      </div>
    </div>
  );
}
function ChestReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img
        src={ChestRewardIco}
        alt="ChestRewardIco"
        className="absolite top-0 translate-y-[2px] h-[38px]"
      />
      <div className={`absolute text-26 font-normal font-Bangers top-[12px] left-[-4px] px-2 
                     text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF] 
                     `}
      >
        {value}
      </div>
    </div>
  );
}
